<template>
<div class="ti">
  <div style="margin-left: 20px; margin-top: 20px; margin-bottom: 20px">
    <el-row>
      <el-col :span="3">
        房产数
        <el-badge  class="mark" :value="status_total['houseNUm']"/>
      </el-col>
      <el-col :span="2">
        <el-checkbox :indeterminate="isIndeterminate" v-model="search.checkAll" @change="handleCheckAllChange">
          全选
          <el-badge class="mark" :value="status_total['total']"/>
        </el-checkbox>
      </el-col>
      <el-col :span="19">
        <el-checkbox-group v-model="search.select_status" @change="handleCheckedCitiesChange">
          <template v-for="(item, index) in search.statusList">
            <el-checkbox :label="item" :key="item">
              {{ item }}
              <el-badge v-if="index == 0" class="mark" :value="status_total['status_0']"/>
              <el-badge v-if="index == 1" class="mark" :value="status_total['status_1']"/>
              <el-badge v-if="index == 2" class="mark" :value="status_total['status_2']"/>
              <el-badge v-if="index == 3" class="mark" :value="status_total['status_3']"/>
              <el-badge v-if="index == 4" class="mark" :value="status_total['status_4']"/>
              <el-badge v-if="index == 5" class="mark" :value="status_total['status_5']"/>
              <el-badge v-if="index == 6" class="mark" :value="status_total['status_6']"/>
            </el-checkbox>
          </template>

        </el-checkbox-group>
      </el-col>

    </el-row>
    <el-row>
      <el-col :span="4">
        分类：
        <el-select v-model="search.type_id" filterable placeholder="选择分类" clearable size="mini">
          <el-option
            v-for="(item,index) in search.type_list"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-col>
      <el-col :span="4">
        战区：
        <el-select v-model="search.region" placeholder="请选择战区" filterable clearable size="mini">
          <template v-for="item in search.region_list">
            <el-option :label="item.name" :value="item.id"/>
            <template v-for="sub in item.children">
              <el-option :label="'  - ' + sub.name" :value="sub.id" />
            </template>
          </template>
        </el-select>
      </el-col>
      <el-col :span="4">
        项目：
        <el-select v-model="search.project" placeholder="请选择项目"  filterable clearable size="mini">
          <template v-for="(item,index) in search.project_list">
            <el-option :label="item.house_name" :value="item.erp_pindex_id"></el-option>
          </template>
        </el-select>
      </el-col>
      <el-col :span="4">
        区域：
        <el-select v-model="search.area" placeholder="请选择区域" filterable clearable size="mini">
          <template v-for="(item,index) in search.area_list">
            <el-option :label="item.house_name" :value="item.house_id"></el-option>
          </template>
        </el-select>
      </el-col>
    </el-row>
    <el-row >
      <el-col :span="24">
        装修申请日期：
        <el-date-picker
          v-model="search.dateArr[0]"
          type="date"
          @change="searchData"
          value-format="yyyy-MM-dd"
          clearable="false"
          placeholder="选择日期">
        </el-date-picker>
        至
        <el-date-picker
          v-model="search.dateArr[1]"
          type="date"
          @change="searchData"
          value-format="yyyy-MM-dd"
          clearable="false"
          placeholder="选择日期">
        </el-date-picker>
      </el-col>


      <el-col :span="4">
        <el-button size="mini" style="color: #FFFFFF" type="primary" @click="searchData">搜索</el-button>
      </el-col>
    </el-row>

  </div>
  <v-divider></v-divider>
  <div class="table-wrap">
    <el-table
            v-loading="loading"
            v-if="pageData" :data="pageData.list"
            border
            style="width: 100%">
            <el-table-column
              prop="ID"
              label="ID"
              width="90">
            </el-table-column>
            <el-table-column
              prop="FitmentID"
              label="装修编号"
              width="150">
              <template slot-scope="scope">
                {{scope.row.FitmentID?scope.row.FitmentID:'无编号'}}
              </template>
            </el-table-column>
            <el-table-column
              prop="house_name"
              label="房产" width="320"></el-table-column>
            <el-table-column
              prop="ApplyDate"
              label="申请时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="customer_name"
              label="业主名称"
              width="120">
            </el-table-column>
            <el-table-column
              prop="ProcessState"
              label="装修状态"
              width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.ProcessState == 0">未审批</span>
                <span v-if="scope.row.ProcessState == 1">审批中</span>
                <span v-if="scope.row.ProcessState == 2">已审批</span>
                <span v-if="scope.row.ProcessState == 3">已缴费</span>
                <span v-if="scope.row.ProcessState == 4">已入场</span>
                <span v-if="scope.row.ProcessState == 5">已取消</span>
                <span v-if="scope.row.ProcessState == 6">已完成</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="TakeChargeName"
              label="责任人"
              width="100">
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange"></el-pagination>
        </div>
</div>
</template>

<script>
// import RepairsDetail from "./RepairsDetail";
import Http from "../../Oa/common/OaHttp";
import UserProjectInfo from "../../Butler/common/UserProjectInfo";

const statusArr = ['未审批', '审批中', '已审批', '已缴费', '已入场', '已完成', '已取消'];
export default {
  name: 'FurnishMasterPreview',
  components: {},
  data () {
    return {
      isIndeterminate: false,
      loading: false,
      status_total: {
        'status_0': 0,
        'status_1': 0,
        'status_2': 0,
        'status_3': 0,
        'status_4': 0,
        'status_5': 0,
        'status_6': 0,
        'total': 0,
        'houseNUm': 0,
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
      search: {
        select_status: [],
        statusList: statusArr,
        dateArr: [],
        region:'',
        region_list: [],
        project:'',
        project_list:[],
        area:'',
        area_list:'',
        project_ids:'',
        type_id:'',
        type_list : []
      },
      dataList : [],
      projectRegion:[],
      projectList:[],
      areaList:[],
      regionListKeyById: {},
    }
  },
  //界面没出来前加载
  created() {

  },

  mounted(){
    this.search.dateArr = this.getNowTime();
  },
  activated(){
    let region =  this.$route.query.region_name;
    let project =  this.$route.query.project_name;
    let member_type =  this.$route.query.member_type;
    let start_date =  this.$route.query.start_date;
    let end_date =  this.$route.query.end_date;

    // this.getRegionList()
    this.search.type_id = 1
    let that = this
    UserProjectInfo.ready(function(){
      that.search.type_list=UserProjectInfo.getTypeList();
      that.search.region_list = UserProjectInfo.getRegionList({type_id:that.search.type_id});
    },1)

  },
  computed:{

  },
  watch: {
    'search.type_id':function(newValue) {
      this.search.region = ''
      this.search.project = ''
      this.search.area = ''
      if (newValue === "") {
        this.search.region_list = []
        this.search.project_list = []
        this.search.area_list = []
      } else {
        this.search.region_list = UserProjectInfo.getRegionList({type_id:newValue});
      }

      this.search.project_ids = UserProjectInfo.getProjectIds({region_id:0,type_id:newValue})
      this.getRepairList()

    },
    'search.region':function(newValue) {
      this.search.project = ''
      this.search.area = ''
      if (newValue === "") {
        this.search.project_list = []
        this.search.area_list = []
      } else {
        this.search.project_list=UserProjectInfo.getProjectList({region_id:this.search.region, type_id:this.search.type_id});
      }

      this.search.project_ids = UserProjectInfo.getProjectIds({region_id:this.search.region, type_id:this.search.type_id})
      this.getRepairList()
    },
    'search.project':function(newValue) {
      this.search.area = ''
      if (newValue === "") {
        this.search.area_list = []
        this.search.project_ids = UserProjectInfo.getProjectIds({region_id:this.search.region, type_id:this.search.type_id})
      } else {
        this.search.project_ids = newValue
        this.search.area_list = UserProjectInfo.getAreaList(newValue);
      }
      this.getRepairList()
    },
    'search.area':function(newValue) {
      this.getRepairList()
    }
  },
  //事件
  methods: {
    handleCheckAllChange(val) {
      this.search.select_status = val ? statusArr : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.search.checkAll = checkedCount === this.search.statusList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.search.statusList.length;
      this.getList()
    },
    searchData() {
      this.getRepairList()
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getRepairList() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      if (this.search.project_ids == '') {
        let projectIds = [];
        for (const k in this.search.region_list) {
          let item = this.search.region_list[k]
          let list = this.getProjectListByRegion(item.id)
          projectIds.push(list.map(item => item.erp_pindex_id))
        }
        this.search.project_ids = projectIds.join(',');
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.$myhttp.post('admin/houseFurnish/furnishPreview',this.search,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];

        if(resData.code == 200){
          this.status_total = resData.data
        }
      });
      this.getList()
    },
    getList() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      if (this.search.project_ids == '') {
        let projectIds = [];
        for (const k in this.search.region_list) {
          let item = this.search.region_list[k]
          let list = this.getProjectListByRegion(item.id)
          projectIds.push(list.map(item => item.erp_pindex_id))
        }
        this.search.project_ids = projectIds.join(',');
      }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.search.page = this.pageData.page;
      this.search.page_size = this.pageData.pageSize;
      this.loading = true
      this.$myhttp.post('admin/houseFurnish/getPreviewList',this.search,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];

        if(resData.code == 1){
          this.pageData = resData.data
          console.log(this.pageData)
        }
      });
    },
    getRegionList() {
      let that = this
      Http.get(Http.getFlowBaseURL() + "/hrm/User/getUserProjectInfo", {'status':0}, res => {
        if (res.code == 0) {
          that.projectRegion = this.getRegionTree(0, res.data.region_list)
          that.projectList = res.data.project_list
          that.areaList = res.data.area_list

          for (const k in res.data.region_list) {
            this.regionListKeyById[res.data.region_list[k]['id']] = res.data.region_list[k];
          }

          that.search.region_list = this.getRegionTree(0, res.data.region_list)
          this.getRepairList()
        }
      });
    },
    // 战区列表转为树结构
    getRegionTree(id, d) {
      let list = []
      for(const k in d) {
        if(d[k].pid == id) {
          let item = d[k]
          item.children = this.getRegionTree(item.id, d)
          list.push(item)
        }
      }
      return list
    },
    selectRegion() {
      this.search.project = '';
      this.search.area = '';
      this.search.project_list = this.getProjectListByRegion(this.search.region);
      this.search.project_ids = this.getProjectIds(this.search);
      this.searchData()
    },
    selectProject() {
      this.search.area = '';
      this.search.area_list = this.getAreaList(this.search.project);
      this.searchData()
    },
    getNowTime() {
      // let start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
      //     .toISOString()
      //     .replace('T', ' ')
      //     .split('.')[0] //默认开始时间7天前

      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      month = month + 1;
      if (month < 10 ) {
        month = '0' + month;
      }
      let start = year + '-' + month + '-01';

      let end = new Date(new Date().getTime())
        .toISOString()
        .replace('T', ' ')
        .split('.')[0]//默认结束时间

      // start = start.substring(0,10)
      end = end.substring(0,10)
      return [start, end]
    },
    // 获取战区项目列表
    getProjectListByRegion(projectRegionId) {
      if (projectRegionId) {
        const regionItem = this.getRegion(projectRegionId)
        return this.projectList.filter(item => regionItem.pindex_id.includes(item.erp_pindex_id + ''))
      } else {
        return this.projectList
      }
    },

    // 获取项目的区域
    getAreaList(projectId) {
      if (projectId) {
        const projectItem = this.getProject(projectId)
        return this.areaList.filter(item => item.erp_pindex_id == projectItem.erp_pindex_id)
      } else {
        return []
      }
    },

    getRegion(id) {
      // let projectRegion = this.projectRegion
      // for (const k in projectRegion) {
      //   if (projectRegion[k].id == id) {
      //     return projectRegion[k]
      //   }
      // }
      return this.regionListKeyById[id];
    },

    getProject(id) {
      let projectList = this.projectList
      for (const k in projectList) {
        if (projectList[k].erp_pindex_id == id) {
          return projectList[k]
        }
      }
    },
    getProjectIds(data){
      let project_id = '';
      if(data.project) {
        project_id = data.project
      } else {
        if(data.region) {
          const list = this.getProjectListByRegion(data.region)
          project_id = list.map(item => item.erp_pindex_id).join(',')
        } else {
          project_id = this.projectList.map(item => item.erp_pindex_id).join(',')
        }
      }
      return project_id;
    }
  },

}
</script>
<style scoped>
.el-row {
  margin-bottom: 10px;
}
.ti{
  margin: 1%;
  width: 98%;
}
.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/FurnishMasterPreview.vue